import "../styles/genai.css";
import aiHeroImg from "../assets/ai-engineer-hero.png";

export default function AIEngineerHero() {
  return (
    <section
      className="genai-hero full-hero"
      style={{
        backgroundImage: `url(${aiHeroImg})`,
      }}
    >
      {/* OVERLAY */}
      <div className="hero-overlay"></div>

      {/* CONTENT */}
      <div className="hero-content">
        <h1 className="hero-title">
          AI ENGINEER PROGRAM
        </h1>

        <p className="hero-desc">
          Learn to Build Intelligent Systems using Artificial Intelligence & Machine Learning
        </p>

      </div>
    </section>
  );
}